// src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import NavBar from './components/NavBar';
import Home from './components/Home';
import ScoreInput from './components/ScoreInput';
import Leaderboard from './components/Leaderboard';
import StatsDashboard from './components/StatsDashboard';
import TeamStats from './components/TeamStats';
import ProfileSettings from './components/ProfileSettings';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <NavBar />
        <main>
          <Routes>
            <Route index element={<Home />} />
            <Route path="/submit" element={<ScoreInput />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/team" element={<TeamStats />} />
            
            {/* DYNAMIC ROUTES FOR STATS */}
            <Route path="/stats" element={<StatsDashboard />} />
            <Route path="/stats/:userId" element={<StatsDashboard />} />
            
            <Route path="/profile" element={<ProfileSettings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  );
}

export default App;